import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["ref"],
  _excluded2 = ["aria-expanded", "aria-haspopup"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { Suspense, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useIntl } from 'react-intl-next';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { GiveKudosLauncherLazy, KudosType } from '@atlaskit/give-kudos';
import Popup from '@atlaskit/popup';
import { layers } from '@atlaskit/theme/constants';
import filterActionsInner from '../../internal/filterActions';
import getLabelMessage from '../../internal/getLabelMessage';
import { CardWrapper } from '../../styled/Card';
import { cardTriggered, fireEvent } from '../../util/analytics';
import { DELAY_MS_HIDE, DELAY_MS_SHOW } from '../../util/config';
import { ProfileCardLazy } from './lazyProfileCard';
import UserLoadingState from './UserLoadingState';
export default function ProfilecardTriggerNext(_ref) {
  var _ref$trigger = _ref.trigger,
    trigger = _ref$trigger === void 0 ? 'hover' : _ref$trigger,
    userId = _ref.userId,
    cloudId = _ref.cloudId,
    resourceClient = _ref.resourceClient,
    _ref$actions = _ref.actions,
    actions = _ref$actions === void 0 ? [] : _ref$actions,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'bottom-start' : _ref$position,
    children = _ref.children,
    testId = _ref.testId,
    addFlag = _ref.addFlag,
    onReportingLinesClick = _ref.onReportingLinesClick,
    ariaLabel = _ref.ariaLabel,
    ariaLabelledBy = _ref.ariaLabelledBy,
    prepopulatedData = _ref.prepopulatedData,
    disabledAriaAttributes = _ref.disabledAriaAttributes,
    onVisibilityChange = _ref.onVisibilityChange;
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMounted = _useState2[0],
    setIsMounted = _useState2[1];
  var showDelay = trigger === 'click' ? 0 : DELAY_MS_SHOW;
  var hideDelay = trigger === 'click' ? 0 : DELAY_MS_HIDE;
  var showTimer = useRef(0);
  var hideTimer = useRef(0);
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    visible = _useState4[0],
    setVisible = _useState4[1];
  var _useState5 = useState(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    hasError = _useState8[0],
    setHasError = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    error = _useState10[0],
    setError = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    data = _useState12[0],
    setData = _useState12[1];
  var _useState13 = useState(undefined),
    _useState14 = _slicedToArray(_useState13, 2),
    reportingLinesData = _useState14[0],
    setReportingLinesData = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    shouldShowGiveKudos = _useState16[0],
    setShouldShowGiveKudos = _useState16[1];
  var _useState17 = useState(undefined),
    _useState18 = _slicedToArray(_useState17, 2),
    teamCentralBaseUrl = _useState18[0],
    setTeamCentralBaseUrl = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    kudosDrawerOpen = _useState20[0],
    setKudosDrawerOpen = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    isTriggeredUsingKeyboard = _useState22[0],
    setTriggeredUsingKeyboard = _useState22[1];
  var triggerRef = useRef(null);
  useEffect(function () {
    setIsMounted(true);
    return function () {
      setIsMounted(false);
      clearTimeout(showTimer.current);
      clearTimeout(hideTimer.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    // Reset state when the userId changes
    setIsLoading(undefined);
    setHasError(false);
    setError(null);
    setData(null);
    setReportingLinesData(undefined);
    setShouldShowGiveKudos(false);
    setTeamCentralBaseUrl(undefined);
  }, [userId]);
  var fireAnalytics = useCallback(function (payload) {
    // Don't fire any analytics if the component is unmounted
    if (!isMounted) {
      return;
    }
    fireEvent(createAnalyticsEvent, payload);
  }, [createAnalyticsEvent, isMounted]);
  var hideProfilecard = useCallback(function () {
    clearTimeout(showTimer.current);
    clearTimeout(hideTimer.current);
    if (!isTriggeredUsingKeyboard) {
      hideTimer.current = window.setTimeout(function () {
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
      }, hideDelay);
    }
  }, [hideDelay, isTriggeredUsingKeyboard, onVisibilityChange]);
  var handleKeyboardClose = useCallback(function (event) {
    if (event.key && event.key !== 'Escape') {
      return;
    }
    if (triggerRef.current) {
      triggerRef.current.focus();
    }
    setTriggeredUsingKeyboard(false);
    setVisible(false);
    onVisibilityChange && onVisibilityChange(false);
  }, [setTriggeredUsingKeyboard, setVisible, onVisibilityChange]);
  var handleClientSuccess = useCallback(function (profileData, reportingLinesData, shouldShowGiveKudos) {
    if (!isMounted) {
      return;
    }
    setIsLoading(false);
    setHasError(false);
    setData(profileData);
    setReportingLinesData(reportingLinesData);
    setShouldShowGiveKudos(shouldShowGiveKudos);
  }, [isMounted, setHasError, setIsLoading, setData, setReportingLinesData, setShouldShowGiveKudos]);
  var handleClientError = useCallback(function (err) {
    if (!isMounted) {
      return;
    }
    setIsLoading(false);
    setHasError(true);
    setError(err);
  }, [isMounted, setHasError, setIsLoading, setError]);
  var clientFetchProfile = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var requests, responses;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(isLoading === true)) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          setTeamCentralBaseUrl(resourceClient.getTeamCentralBaseUrl());
          setIsLoading(true);
          setHasError(false);
          setError(null);
          setData(null);
          _context.prev = 7;
          requests = Promise.all([resourceClient.getProfile(cloudId || '', userId, fireAnalytics), resourceClient.getReportingLines(userId), resourceClient.shouldShowGiveKudos()]);
          _context.next = 11;
          return requests;
        case 11:
          responses = _context.sent;
          handleClientSuccess.apply(void 0, _toConsumableArray(responses));
          _context.next = 18;
          break;
        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](7);
          handleClientError(_context.t0);
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[7, 15]]);
  })), [cloudId, fireAnalytics, isLoading, resourceClient, userId, handleClientSuccess, handleClientError]);
  var showProfilecard = useCallback(function () {
    clearTimeout(hideTimer.current);
    clearTimeout(showTimer.current);
    showTimer.current = window.setTimeout(function () {
      if (!visible) {
        void clientFetchProfile();
        setVisible(true);
        onVisibilityChange && onVisibilityChange(true);
      }
    }, showDelay);
  }, [showDelay, visible, clientFetchProfile, onVisibilityChange]);
  var onClick = useCallback(function (event) {
    // If the user clicks on the trigger then we don't want that click event to
    // propagate out to parent containers. For example when clicking a mention
    // lozenge in an inline-edit.
    event.stopPropagation();
    showProfilecard();
    if (!visible) {
      fireAnalytics(cardTriggered('user', 'click'));
    }
  }, [fireAnalytics, showProfilecard, visible]);
  var onMouseEnter = useCallback(function () {
    showProfilecard();
    if (!visible) {
      fireAnalytics(cardTriggered('user', 'hover'));
    }
  }, [fireAnalytics, showProfilecard, visible]);
  var onKeyPress = useCallback(function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      setTriggeredUsingKeyboard(true);
      showProfilecard();
      if (!visible) {
        fireAnalytics(cardTriggered('user', 'click'));
      }
    }
  }, [fireAnalytics, showProfilecard, visible]);
  var onFocus = useCallback(function () {
    showProfilecard();
  }, [showProfilecard]);
  var containerListeners = useMemo(function () {
    return trigger === 'hover' ? {
      onMouseEnter: onMouseEnter,
      onMouseLeave: hideProfilecard,
      onBlur: hideProfilecard,
      onKeyPress: onKeyPress
    } : {
      onClick: onClick,
      onKeyPress: onKeyPress
    };
  }, [hideProfilecard, onClick, onKeyPress, onMouseEnter, trigger]);
  var filterActions = useCallback(function () {
    return filterActionsInner(actions, data);
  }, [actions, data]);
  var openKudosDrawer = function openKudosDrawer() {
    hideProfilecard();
    setKudosDrawerOpen(true);
  };
  var closeKudosDrawer = function closeKudosDrawer() {
    setKudosDrawerOpen(false);
  };
  var showLoading = isLoading === true || isLoading === undefined;
  var wrapperProps = useMemo(function () {
    return trigger === 'hover' ? {
      onMouseEnter: onMouseEnter,
      onMouseLeave: hideProfilecard,
      onFocus: onFocus
    } : {};
  }, [hideProfilecard, onFocus, onMouseEnter, trigger]);
  var profilecardProps = _objectSpread(_objectSpread({
    userId: userId,
    fullName: prepopulatedData === null || prepopulatedData === void 0 ? void 0 : prepopulatedData.fullName,
    isCurrentUser: data === null || data === void 0 ? void 0 : data.isCurrentUser,
    clientFetchProfile: clientFetchProfile
  }, data), {}, {
    reportingLines: reportingLinesData,
    onReportingLinesClick: onReportingLinesClick,
    isKudosEnabled: shouldShowGiveKudos,
    teamCentralBaseUrl: teamCentralBaseUrl,
    cloudId: cloudId,
    openKudosDrawer: openKudosDrawer,
    isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
    disabledAriaAttributes: disabledAriaAttributes
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Popup, {
    isOpen: !!visible,
    onClose: function onClose(event) {
      hideProfilecard();
      handleKeyboardClose(event);
    },
    placement: position,
    content: function content() {
      return /*#__PURE__*/React.createElement("div", wrapperProps, showLoading ? /*#__PURE__*/React.createElement(LoadingView, {
        fireAnalytics: fireAnalytics
      }) : visible && /*#__PURE__*/React.createElement(Suspense, {
        fallback: null
      }, /*#__PURE__*/React.createElement(ProfileCardLazy, _extends({}, profilecardProps, {
        actions: filterActions(),
        hasError: hasError,
        errorType: error,
        withoutElevation: true
      }))));
    },
    trigger: function trigger(triggerProps) {
      var callbackRef = triggerProps.ref,
        innerProps = _objectWithoutProperties(triggerProps, _excluded);
      var ref = function ref(element) {
        triggerRef.current = element;
        if (typeof callbackRef === 'function') {
          callbackRef(element);
        }
      };
      var _ = innerProps['aria-expanded'],
        __ = innerProps['aria-haspopup'],
        restInnerProps = _objectWithoutProperties(innerProps, _excluded2);
      return /*#__PURE__*/React.createElement("span", _extends({}, disabledAriaAttributes ? restInnerProps : triggerProps, containerListeners, {
        ref: ref,
        "data-testid": testId,
        "aria-labelledby": ariaLabelledBy
      }, disabledAriaAttributes ? {} : {
        role: 'button',
        tabIndex: 0,
        'aria-label': getLabelMessage(ariaLabel, profilecardProps.fullName, formatMessage)
      }), children);
    },
    zIndex: layers.modal(),
    shouldUseCaptureOnOutsideClick: true,
    autoFocus: trigger === 'click'
  }), shouldShowGiveKudos && /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(GiveKudosLauncherLazy, {
    isOpen: kudosDrawerOpen,
    recipient: {
      type: KudosType.INDIVIDUAL,
      recipientId: userId
    },
    analyticsSource: "profile-card",
    teamCentralBaseUrl: teamCentralBaseUrl,
    cloudId: cloudId,
    addFlag: addFlag,
    onClose: closeKudosDrawer
  })));
}
var LoadingView = function LoadingView(_ref3) {
  var fireAnalytics = _ref3.fireAnalytics;
  return /*#__PURE__*/React.createElement(CardWrapper, {
    "data-testId": "profilecard.profilecardtrigger.loading"
  }, /*#__PURE__*/React.createElement(UserLoadingState, {
    fireAnalytics: fireAnalytics
  }));
};